import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-color-config-view',
  standalone: true,
  templateUrl: './color-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
